export default {
  list: {
    page: 1,
    perPage: 50,
    sortKey: null,
    sortDirection: null,
    sortKeyDefault: null,
    sortDirectionDefault: null
  }
} as RetailMediaPlacementsState
